import KalviumSDK from '@kalvi-education/kalvium-sdk'

import ATTEMPT_ACTION from '../../enums/attemptActions'
import ATTEMPT_TYPE from '../../enums/attemptTypes'
import PROCTORING_IMAGE_TYPE from '../../enums/proctoringImageType'
import { b64toBlob } from '../../utils/common'
import {applyPreviewAssessmentConfig} from '../../utils/previewAssessment'

let isSaveEventLogPreviewAttempt = false

const setSaveEventLogPreviewMode = value => {
    isSaveEventLogPreviewAttempt = value === true
}

const fetchAssessmentDetails = async (
    ax_slug,
    dispatch,
    attemptData,
    navigate
) => {
    try {
        const rawAxDetails =
            await KalviumSDK.services.assessment.fetchAssessmentDetails(ax_slug)
        const axDetails = applyPreviewAssessmentConfig(
            rawAxDetails,
            attemptData?.extras?.is_preview === true
        )
        dispatch({
            type: ATTEMPT_ACTION.SET_DATA,
            payload: {
                axDetails,
                attemptData: attemptData,
            },
        })
    } catch (error) {
        // Check if assessment details is not found
        if (error.message === 'Assessment not found') {
            navigate('/404', { replace: true })
        } else {
            console.error('Assessment details fetch API failed', error)
        }
    }
}

const fetchTryoutDetails = async (ax_slug, dispatch, attemptData, navigate) => {
    try {
        const rawAxDetails = await KalviumSDK.services.assessment.fetchTryoutDetails(
            ax_slug
        )
        const axDetails = applyPreviewAssessmentConfig(
            rawAxDetails,
            attemptData?.extras?.is_preview === true
        )
        dispatch({
            type: ATTEMPT_ACTION.SET_DATA,
            payload: {
                axDetails,
                attemptData: attemptData,
            },
        })
    } catch (error) {
        // Check if assessment details is not found
        if (error.message === 'Assessment not found') {
            navigate('/404', { replace: true })
        } else {
            console.error('Assessment details fetch API failed', error)
        }
    }
}

const uploadProctoringImage = async ({
    token,
    type,
    imgData,
    attemptId,
    isTryout,
    fileName,
    onError,
}) => {
    try {
        const captureTs = Math.round(Date.now() / 1000)
        const blob = b64toBlob(
            imgData.replace('data:image/jpeg;base64,', ''),
            'image/jpeg'
        )
        const file = new File([blob], { type: 'image/jpeg' })
        const data = {
            attemptId: attemptId,
            action:
                type === PROCTORING_IMAGE_TYPE.SCREEN
                    ? 'upload_screenshot'
                    : 'upload_camera_image',
            params: { filename: fileName, capture_ts: captureTs },
            file: file,
            token: token,
        }

        if (isTryout) {
            await KalviumSDK.services.attempt.uploadOAFile(data)
        } else {
            await KalviumSDK.services.attempt.uploadFile(data)
        }
        return true
    } catch (error) {
        console.error(error)
        onError?.(error)
        return false
    }
}

const saveEventLog = async ({attemptId, isTryout, token, events}) => {
    if (isSaveEventLogPreviewAttempt && events?.length) {
        return { skipped: true }
    }

    if (isTryout) {
        return await KalviumSDK.services.attempt.saveOpenAttempt({
            attemptId: attemptId,
            action: ATTEMPT_TYPE.LOG,
            events: events,
            token: token,
        })
    } else {
        return await KalviumSDK.services.attempt.saveAttempt({
            attemptId: attemptId,
            action: ATTEMPT_TYPE.LOG,
            events: events,
        })
    }
}

const saveIntegrityCheckLog = async (attemptId, assessmentSlug, questionId) => {
    return await KalviumSDK.services.attempt.saveIntegrityLogs({
        attemptId: attemptId,
        action: ATTEMPT_TYPE.INTEGRITY_CHECK,
        questionId,
        assessmentSlug,
    })
}

export {
    fetchAssessmentDetails,
    fetchTryoutDetails,
    saveEventLog,
    saveIntegrityCheckLog,
    setSaveEventLogPreviewMode,
    uploadProctoringImage,
}
